import { environment } from '../../../environments/environment';

/**
 * @description Builds a language-aware URL for the Exploris Health website
 * @param currentLang - Current language code ('en' or 'de')
 * @param path - The path/hash to append (e.g., '#faq', '#contact')
 * @returns The complete URL with language prefix for German, base URL for English
 *
 * @example
 * getExplorisHealthUrl('en', '#contact') // returns 'https://www.cardioexplorer.ai/#contact'
 * getExplorisHealthUrl('de', '#contact') // returns 'https://www.cardioexplorer.ai/de/#contact'
 */
export function getExplorisHealthUrl(currentLang: string, path = ''): string {
  const baseUrl = environment.explorisHealthBaseUrl;
  const langPrefix = currentLang === 'en' ? '' : `/${currentLang}`;
  return `${baseUrl}${langPrefix}${path}`;
}
